import ViewSurvey from "../../../Client/detail/components/Units/ViewSurvey";
import RedirectToClient from "../../../Tickets/components/RedirectToClient";
import InspectionScheduled from "./InspectionScheduled";
import WindowGuards from "./WindowGuards";
import KnobCovers from "./KnobCovers";
import ApartmentNumberColumns from "./ApartmentNumberColumns";
import DownloadUnitSurveyForm from "./DownloadUnitSurveyForm";
import { isAdmin, isSelfService } from "../../../../utils/helpers";
import { downloadPendingMailer } from "../../../../sevices/leadComplianceApi";

export const columns = [
  ...(isAdmin() ? [{
    field: "client",
    headerName: "Client",
    renderCell: (params) => {
      return <RedirectToClient params={params} />;
    },
    minWidth: 180,
    flex: 1.5,
    // editable: true,
    // sortable: false,
  },]:[]),
  {
    field: "building_address",
    headerName: "Building",
    renderCell: (params) => {
      return <p className="">{params.value}</p>;
    },
    minWidth: 180,
    flex: 1.5,
    // editable: true,
    // sortable: false,
  },

  {
    field: "unit_number",
    headerName: "Unit",
    renderCell: (params) => {
      return <ApartmentNumberColumns params={params} />;
    },
    minWidth: 100,
    flex: 0.7,
    // editable: true,
    // sortable: false,
  },
  {
    field: "mailer_count",
    headerName: "Mailers Send",
    renderCell: (params) => {
      return <p className="">{params.value}</p>;
    },
    minWidth: 100,
    flex: 1,
    // editable: true,
    sortable: false,
  },
  // {
  //   field: "response_type",
  //   headerName: "Response Type",
  //   renderCell: (params) => {
  //     return <p className="">{params.row.compliance?.response_type || ''}</p>;
  //   },
  //   minWidth: 100,
  //   flex: 1,
  //   // editable: true,
  //   sortable: false,
  // },
  {
    field: "window_guards_installed",
    headerName: "Window Guards",
    renderCell: (params) => {
      return <WindowGuards params={params} />;
    },
    minWidth: 150,
    flex: 1,
    // editable: true,
    sortable: false,
  },
  {
    field: "knob_covers",
    headerName: "Knob Covers",
    renderCell: (params) => {
      return <KnobCovers params={params} />;
    },
    minWidth: 150,
    flex: 1,
    // editable: true,
    sortable: false,
  },
  {
    field: "inspection",
    headerName: "Visual Inspection",
    renderCell: (params) => {
      return (
        <>
          <InspectionScheduled
            params={params}
            key={`schedule_inspection_${params.row?.compliance?.compliance_id}`}
          />
        </>
      );
    },
    renderHeader: (cell) => (
      <div className="w-100 d-flex justify-content-center">
        <p className="size-14 text-color weight-500">Visual Inspection</p>
      </div>
    ),
    minWidth: 150,
    flex: 1,
    // editable: true,
    sortable: false,
    headerClassName: "center-header",
  },
  {
    field: "survey",
    headerName: "Survey",
    renderCell: (params) => {
      const { building_id, unit_number, compliance } = params.row;
      const props = {
        unit_id: compliance.unit_id,
        building_id,
        unit_number,
        api: downloadPendingMailer,
      };
      return (
        <div className="w-100 d-flex justify-content-center">
          {compliance.status != "pending" &&
          compliance.status ?  <ViewSurvey params={params} /> :
          (isAdmin() || isSelfService()) ? <DownloadUnitSurveyForm  {...props}/> : ''
          }
        </div>
      );
    },
    renderHeader: (cell) => (
      <div className="w-100 d-flex justify-content-center">
        <p className="size-14 text-color weight-500">Survey</p>
      </div>
    ),
    minWidth: 110,
    flex: 0.8,
    // editable: true,
    sortable: false,
    headerClassName: "center-header ",
  },
];
